function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/dataprocessor/htmldataprocessor
 */

/* globals document, DOMParser, Node */
import BasicHtmlWriter from './basichtmlwriter';
import DomConverter from '../view/domconverter';
/**
 * The HTML data processor class.
 * This data processor implementation uses HTML as input and output data.
 *
 * @implements module:engine/dataprocessor/dataprocessor~DataProcessor
 */

var HtmlDataProcessor = /*#__PURE__*/function () {
  /**
   * Creates a new instance of the HTML data processor class.
   *
   * @param {module:engine/view/document~Document} document The view document instance.
   */
  function HtmlDataProcessor(document) {
    _classCallCheck(this, HtmlDataProcessor);

    /**
     * A DOM parser instance used to parse an HTML string to an HTML document.
     *
     * @private
     * @member {DOMParser}
     */
    this._domParser = new DOMParser();
    /**
     * A DOM converter used to convert DOM elements to view elements.
     *
     * @private
     * @member {module:engine/view/domconverter~DomConverter}
     */

    this._domConverter = new DomConverter(document, {
      blockFillerMode: 'nbsp'
    });
    /**
     * A basic HTML writer instance used to convert DOM elements to an HTML string.
     *
     * @private
     * @member {module:engine/dataprocessor/basichtmlwriter~BasicHtmlWriter}
     */

    this._htmlWriter = new BasicHtmlWriter();
  }
  /**
   * Converts a provided {@link module:engine/view/documentfragment~DocumentFragment document fragment}
   * to data format &mdash; in this case to an HTML string.
   *
   * @param {module:engine/view/documentfragment~DocumentFragment} viewFragment
   * @returns {String} HTML string.
   */


  _createClass(HtmlDataProcessor, [{
    key: "toData",
    value: function toData(viewFragment) {
      // Convert view DocumentFragment to DOM DocumentFragment.
      var domFragment = this._domConverter.viewToDom(viewFragment, document); // Convert DOM DocumentFragment to HTML output.


      return this._htmlWriter.getHtml(domFragment);
    }
    /**
     * Converts the provided HTML string to a view tree.
     *
     * @param {String} data An HTML string.
     * @returns {module:engine/view/node~Node|module:engine/view/documentfragment~DocumentFragment|null} A converted view element.
     */

  }, {
    key: "toView",
    value: function toView(data) {
      // Convert input HTML data to DOM DocumentFragment.
      var domFragment = this._toDom(data); // Convert DOM DocumentFragment to view DocumentFragment.


      return this._domConverter.domToView(domFragment);
    }
    /**
     * Registers a {@link module:engine/view/matcher~MatcherPattern} for view elements whose content should be treated as raw data
     * and not processed during the conversion from the DOM to the view elements.
     *
     * The raw data can be later accessed by a
     * {@link module:engine/view/element~Element#getCustomProperty custom property of a view element} called `"$rawContent"`.
     *
     * @param {module:engine/view/matcher~MatcherPattern} pattern Pattern matching all view elements whose content should
     * be treated as raw data.
     */

  }, {
    key: "registerRawContentMatcher",
    value: function registerRawContentMatcher(pattern) {
      this._domConverter.registerRawContentMatcher(pattern);
    }
    /**
     * If the processor is set to use marked fillers, it will insert `&nbsp;` fillers wrapped in `<span>` elements
     * (`<span data-cke-filler="true">&nbsp;</span>`) instead of regular `&nbsp;` characters.
     *
     * This mode allows for more precise handling of block fillers (so they do not leak into the editor content) but bloats the
     * editor data with additional markup.
     *
     * This mode may be required by some features and will be turned on by them automatically.
     *
     * @param {'default'|'marked'} type Whether to use the default or marked `&nbsp;` block fillers.
     */

  }, {
    key: "useFillerType",
    value: function useFillerType(type) {
      this._domConverter.blockFillerMode = type == 'marked' ? 'markedNbsp' : 'nbsp';
    }
    /**
     * Converts an HTML string to its DOM representation. Returns a document fragment containing nodes parsed from
     * the provided data.
     *
     * @private
     * @param {String} data
     * @returns {DocumentFragment}
     */

  }, {
    key: "_toDom",
    value: function _toDom(data) {
      var document = this._domParser.parseFromString(data, 'text/html');

      var fragment = document.createDocumentFragment(); // The rules for parsing an HTML string can be read on https://html.spec.whatwg.org/multipage/parsing.html#parsing-main-inhtml.
      //
      // In short, parsing tokens in an HTML string starts with the so-called "initial" insertion mode. When a DOM parser is in this
      // state and encounters a comment node, it inserts this comment node as the last child of the newly-created `HTMLDocument` object.
      // The parser then proceeds to successive insertion modes during parsing subsequent tokens and appends in the `HTMLDocument` object
      // other nodes (like <html>, <head>, <body>). This causes that the first leading comments from HTML string become the first nodes
      // in the `HTMLDocument` object, but not in the <body> collection, because they are ultimately located before the <html> element.
      //
      // Therefore, so that such leading comments do not disappear, they all are moved from the `HTMLDocument` object to the document
      // fragment, until the <html> element is encountered.
      //
      // See: https://github.com/ckeditor/ckeditor5/issues/9861.

      var documentChildNode = document.firstChild;

      while (!documentChildNode.isSameNode(document.documentElement)) {
        var node = documentChildNode;
        documentChildNode = documentChildNode.nextSibling; // It seems that `DOMParser#parseFromString()` adds only comment nodes directly to the `HTMLDocument` object, before the <html>
        // node. The condition below is just to be sure we are moving only comment nodes.

        /* istanbul ignore else */

        if (node.nodeType == Node.COMMENT_NODE) {
          fragment.appendChild(node);
        }
      }

      var bodyChildNodes = document.body.childNodes;

      while (bodyChildNodes.length > 0) {
        fragment.appendChild(bodyChildNodes[0]);
      }

      return fragment;
    }
  }]);

  return HtmlDataProcessor;
}();

export { HtmlDataProcessor as default };